const encodeQueryComponent = (value: unknown): string =>
  encodeURIComponent(String(value))
    .replace(/%3A/gi, ':')
    .replace(/%24/g, '$')
    .replace(/%2C/gi, ',')
    .replace(/%20/g, '+');

const normalizeQueryValue = (value: unknown): unknown => {
  if (Object.prototype.toString.call(value) === '[object Date]') {
    return (value as Date).toISOString();
  }
  if (value !== null && typeof value === 'object') {
    return JSON.stringify(value);
  }
  return value;
};

/**
 * Axios 0.27 deliberately restores encoded square brackets in query strings.
 * Tomcat rejects those raw reserved characters before a request reaches Spring.
 * Keep Axios' established parameter semantics while leaving brackets percent-encoded.
 */
export const serializeStrictQueryParams = (params: unknown): string => {
  if (
    typeof URLSearchParams !== 'undefined' &&
    Object.prototype.toString.call(params) === '[object URLSearchParams]'
  ) {
    return String(params);
  }
  if (params === null || typeof params !== 'object') {
    return '';
  }

  const parts: string[] = [];
  Object.entries(params).forEach(([originalKey, originalValue]) => {
    if (originalValue === null || typeof originalValue === 'undefined') {
      return;
    }

    const isArray = Array.isArray(originalValue);
    const key = isArray ? `${originalKey}[]` : originalKey;
    const values = isArray ? originalValue : [originalValue];

    for (let index = 0; index < values.length; index += 1) {
      const value = values[index];
      const normalizedValue = normalizeQueryValue(value);
      parts.push(
        `${encodeQueryComponent(key)}=${encodeQueryComponent(normalizedValue)}`,
      );
    }
  });

  return parts.join('&');
};
